import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AmplifyAuthenticatorModule, AuthenticatorService } from '@aws-amplify/ui-angular';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AmplifyModelService } from '../../services/amplify-model-service.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css',
  imports: [
    AmplifyAuthenticatorModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class LoginPageComponent {
  
  private authService = inject(AmplifyModelService);
  private navigationService = inject(NavigationService);
  
  constructor(
    private router: Router,
    public authenticator: AuthenticatorService
  ) {}

  goBack() {
    this.router.navigate(['/']);
  }

  async onAuthSuccess() {
    try {
      console.log('🎉 Login successful! Determining user portal...');
      const groups = await this.authService.getUserGroups();
      const defaultRoute = this.navigationService.getDefaultRouteForGroups(groups);
      console.log('🔄 Login redirect to:', defaultRoute);
      this.router.navigate([defaultRoute]);
    } catch (error) {
      console.error('❌ Error during login redirect:', error);
      // Fallback to dashboard if there's an error
      this.router.navigate(['/dashboard']);
    }
  }
}